<script>
import { mapState, mapActions } from 'vuex';
/* components */
import Button from '@/components/Button';
import InputBlock from '@/components/InputBlock';
/* tools */
import {} from '@/scripts/utils';
import { changePassword } from '@/scripts/api/account';

export default {
  name: 'ChangePassword',
  components: {
    Button,
    InputBlock,
  },
  props: {
    show: {
      type: Boolean,
      default: !false,
    },
  },
  data() {
    return {
      defaultValues: null,
      defaultTypes: null,
      values: null,
      types: null,
    };
  },
  computed: {
    ...mapState(['user']),
    isValid() {
      const { values } = this;
      const { current, _new, confirm } = values;
      const result = !!(current && _new && _new === confirm);
      /*  && password && acceptTerms */

      return result;
    },
  },
  created() {
    this.fields = [
      { id: 'current', name: 'Current' },
      { id: '_new', name: 'New' },
      { id: 'confirm', name: 'Confirm' },
    ];

    const defaultValues = {
      current: '',
      _new: '',
      confirm: '',
    };

    const defaultTypes = {
      current: 'password',
      _new: 'password',
      confirm: 'password',
    };

    this.defaultValues = { ...defaultValues };
    this.defaultTypes = { ...defaultTypes };
    this.values = { ...defaultValues };
    this.types = { ...defaultTypes };
  },
  mounted() {},
  methods: {
    ...mapActions({}),
    savePassword() {
      const { values } = this;
      const { _new: newPassword, current: currentPassword } = values;
      const payload = { currentPassword, newPassword };

      changePassword(payload).then(() => {
        this.values = this.defaultValues;
        this.types = this.defaultTypes;

        this.$router.push('/settings');
      });
    },
    switchVisibility(id) {
      const { types } = this;
      const currentVal = types[id];
      const nextVal = currentVal === 'password' ? 'text' : 'password';

      this.$set(this.types, id, nextVal);
    },
  },
};
</script>

<template>
  <!-- changePassword -->
  <div class="settings">
    <div class="settings__content">
      <div class="settings__title">
        <!-- back -->
        <router-link to="/settings" class="settings__arrow">
          <img :src="require('@/assets/svg/arrow-left.svg')" />
        </router-link>
        <span>Change Password</span>
      </div>

      <div class="settings__form">
        <div class="form">
          <!-- >map = fields -->
          <div v-for="{ id, name } in fields" :key="id" class="form__row">
            <InputBlock
              :type="types[id]"
              :forceValue="values[id]"
              @input="val => (values[id] = val)"
            >
              <template #label>
                <span class="label">{{ name }} Password </span>
              </template>
              <template #btnShow>
                <div
                  :class="{
                    'btn-show': true,
                    active: types[id] === 'text',
                  }"
                  @click="switchVisibility(id)"
                >
                  <img :src="require('@/assets/svg/idea.svg')" />
                  <img :src="require('@/assets/svg/idea-active.svg')" />
                </div>
              </template>
            </InputBlock>
          </div>
          <!-- <map -->

          <!-- save -->
          <div class="form__row form__row--btn-right">
            <Button class="orange" :disabled="!isValid" @click="savePassword">
              Change Password
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.settings {
  &__content {
    max-width: 570px;
    width: 100%;
    padding: 40px 30px 50px 0;
  }

  &__title {
    font-family: Poppins-Light;
    font-size: 36px;
    line-height: 51px;
    color: #ffffff;
    margin: 0 0 30px;
    display: flex;
    align-items: center;
  }

  &__arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    cursor: pointer;
    transition: all 0.2;

    img {
      width: 16px;
      height: 14px;
      display: flex;
    }

    &:hover {
      opacity: 0.7;
    }
  }
}

.form {
  width: 100%;

  &__row {
    width: 100%;

    & + & {
      margin-top: 30px;
    }

    & + &--btn,
    & + &--btn-right {
      margin-top: 50px;
    }

    &--btn-right {
      display: flex;
      justify-content: flex-end;
      width: 100%;
    }
  }
}

.btn-show {
  width: 12px;
  height: 16px;
  display: flex;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }

  img {
    display: flex;
    width: 100%;
    height: 100%;
  }

  img:last-child {
    display: none;
  }

  &.active {
    img {
      &:last-child {
        display: flex;
      }

      &:first-child {
        display: none;
      }
    }
  }
}

.label {
  font-family: Poppins-Regular;
  font-size: 14px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.7);
}

@media (max-width: $mobile) {
  .settings {
    &__content {
      padding: 20px 15px 80px;
    }

    &__title {
      font-size: 21px;
      line-height: 29px;
    }
  }

  .form {
    &__row {
      & + &--btn,
      & + &--btn-right {
        margin-top: 40px;
      }
    }
  }

  .label {
    font-size: 12px;
    line-height: 17px;
  }
}
</style>
